





















































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { STATUSES as BOOKING_CANDIDATE_STATUSES } from '@/constants/booking_candidate';
import { STATUSES as PAYMENT_STATUSES } from '@/constants/payment';
import ServiceOrderCreate from '@/pages/Candidate/ServiceOrder/ServiceOrderCreate.vue';
import ServiceOrderRead from '@/pages/Candidate/ServiceOrder/ServiceOrderRead.vue';
import _ from 'lodash';

@Component({
  components: {
    ServiceOrderCreate,
    ServiceOrderRead,
  },
  computed: {
    ...mapState('Auth', {
      candidate: 'candidate',
    }),
    ...mapState('BookingCandidate', {
      bookingCandidate: 'bookingCandidate',
    }),
  },
})
export default class BookingCandidateReadServiceOrderDetails extends Vue {
  isLoading = false;

  // bookingCandidate State
  bookingCandidate!: BookingCandidate;
  candidate!: Model;

  bookingCandidateStatuses = BOOKING_CANDIDATE_STATUSES;
  paymentStatues = PAYMENT_STATUSES;

  showServiceOrderCreate = false;
  showServiceOrderRead = false;

  serviceItems!: Model[];
  serviceItemTotalAvailableQuantity!: [];
  isApiFetch = {
    isApiFetchServiceItemsFinished: false,
    isApiFetchServiceItemTotalAvailableQuantityFinished: false,
  };

  isEnoughAssessment = false;
  isConsumingAssessment = false;
  assessmentAvailable = 0;

  beforeMount() {
    this.init();
  }

  init() {
    this.isLoading = true;

    this.isApiFetch = {
      isApiFetchServiceItemsFinished: false,
      isApiFetchServiceItemTotalAvailableQuantityFinished: false,
    };

    this.$store.dispatch('ServiceItem/fetchList').then((response) => {
      this.serviceItems = response.data.data;
      this.isApiFetch['isApiFetchServiceItemsFinished'] = true;
    });

    this.$store
      .dispatch(
        'Candidate/serviceItemTotalAvailableQuantity',
        this.candidate.object_id
      )
      .then((response) => {
        this.serviceItemTotalAvailableQuantity = response.data.data;
        this.isApiFetch[
          'isApiFetchServiceItemTotalAvailableQuantityFinished'
        ] = true;
      });
  }

  @Watch('isApiFetch', { deep: true })
  watchIsApiFetch(newVal) {
    if (newVal) {
      let isFinished = true;
      for (const [key, value] of Object.entries(this.isApiFetch)) {
        if (!value) {
          isFinished = false;
        }
      }

      if (!isFinished) {
        return;
      }

      // When all APIs call finished, calculate current business available questack quantity,
      // and how many questack against to the SI will be consumed.
      for (const item of this.serviceItems) {
        if (item.object_id) {
          // assign available quantity to SI.current_quantity
          item.current_quantity = _.get(
            this.serviceItemTotalAvailableQuantity,
            item.object_id,
            0
          );

          if (item.key == 'assessment') {
            // get SI(assessment) available questack quantity
            this.assessmentAvailable = _.get(
              this.serviceItemTotalAvailableQuantity,
              item.object_id,
              0
            );
            // decide if current booking has enough questack
            if (this.assessmentAvailable >= 1) {
              this.isEnoughAssessment = true;
            }
            // calculate the required questacks (if candidate don't have enough questack)
            item.required_quantity = 1;
          } else {
            // other SI, no need to set required_quantity
            item.required_quantity = 0;
          }
        }
      }
      this.isLoading = false;
    }
  }

  async consume() {
    this.isConsumingAssessment = true;
    await this.$store.dispatch('BookingCandidate/consume');
    await this.$emit('consume');
    this.showServiceOrderRead = false;
    this.showServiceOrderCreate = false;
    this.init();
  }

  beforePay() {
    return this.$route.params.bookingCandidateOid;
  }

  async afterPay(payment, result) {
    this.$emit('paid', {
      payment,
      result,
    });
  }
}
